import { render, staticRenderFns } from "./ModalOsAVencer.vue?vue&type=template&id=47f7b4fe&scoped=true&"
import script from "./ModalOsAVencer.vue?vue&type=script&lang=js&"
export * from "./ModalOsAVencer.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsAVencer.vue?vue&type=style&index=0&id=47f7b4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7b4fe",
  null
  
)

export default component.exports